import { useAxios } from '../Plugins/axios';
import { useRoute } from '../Plugins/ziggy';
export default class OrchardService {
    axios;
    route;
    constructor() {
        this.axios = useAxios();
        this.route = useRoute();
    }
    getAll() {
        return this.axios
            .get(this.route('api.orchards.index'))
            .then((response) => response.data.data);
    }
}
